(() => {
  if (customElements.get('bar-slider')) {
    return;
  }

  class BarSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        type: 'loop',
        waitForTransition: false,
        perPage: 1,
        autoplay: true,
        interval: this.dataset.interval,
        rewind: true,
        rewindByDrag: true,
        arrows: false,
        pagination: false,
        adaptiveHeight: true,
        height: 40,
        direction: 'ttb',
        drag: false,
        breakpoints: {
          767: {
            height: 35
          }}
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.js-slider')) return;

      this.slider = new Splide(
        this.querySelector('.js-slider'),
        this.options
      ).mount();
    }
  }

  customElements.define('bar-slider', BarSlider);
})();
